exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-wrapper{position:relative}.table-row td{font-weight:300}.table-row__active td{opacity:1}.table-row__archived td{opacity:.5}.table-row_max-value{font-weight:700!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-398194f3","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/table_module/Table.vue
// module id = 76
// module chunks = 0